import { ref, computed } from 'vue'
import { useStore } from 'vuex'

export default function useRequest (data, route, isTool) {
  const dataTableRequest = ref([])
  const dataSelected = ref()
  const store = useStore()
  const lang = computed(() => store.getters['app/lang'])
  data.value.forEach(items => {
    if (items.item) {
      items.item.forEach(item => {
        if (item.name === route) {
          dataSelected.value = item
        }
      })
    }
  })
  let selected, required, description
  const requestData = dataSelected.value.request
  // Read url.query and body.formdata independently (not branched by HTTP method):
  // some non-GET endpoints (e.g. "Store Uom Delete") carry their only parameter(s)
  // in url.query with body.mode "none", and some carry both (e.g. "Store Uom Update").
  if (requestData.url && requestData.url.query) {
    const params_data = requestData.url.query
    params_data.forEach((item, index) => {
      if (params_data[index].description) {
        selected = JSON.parse(params_data[index].description)
      }
      if (selected) {
        if (selected.required === 0) {
          required = 'nullable'
        } else if (selected.required === 1) {
          required = 'required'
        } else {
          required = 'optional'
        }
        if (lang.value === 'id') {
          description = selected.desc_id
        } else {
          description = selected.desc_en
        }
        dataTableRequest.value.push({
          name: params_data[index].key,
          value: isTool ? params_data[index].value : null,
          description: description,
          type: selected.type,
          required: required
        })
      }
    })
  }
  if (requestData.body && requestData.body.formdata) {
    requestData.body.formdata.forEach(item => {
      if (item.description) {
        selected = JSON.parse(item.description)
      }
      if (selected) {
        if (selected.required === 0) {
          required = 'nullable'
        } else if (selected.required === 1) {
          required = 'required'
        } else {
          required = 'optional'
        }
        if (lang.value === 'id') {
          description = selected.desc_id
        } else {
          description = selected.desc_en
        }
        dataTableRequest.value.push({
          name: item.key,
          value: isTool ? item.value : null,
          description: description,
          type: selected.type,
          required: required
        })
      }
    })
  }

  return {
    dataSelected,
    dataTableRequest
  }
}
